<template>
	<div class="storageoutprint" :style="{ height: `${windowHeight}px`, 'overflow-y': 'auto' }">
		<el-form>
			<el-row style="margin-top:30px">
				<el-col :span="3"><span style="color:transparent">1</span></el-col>
				<el-col :span="18">
					<table style="width:100%" align="center">
						<tr>
							<td colspan="2">
								<div style="text-align:center; font-size:16pt;font-weight: bold;">已出库 {{scancount}} 单</div>
							</td>
						</tr>
						<tr>
							<td valign="top">
								<div class="formContent" style="margin-top:10px">
								<table class="htmltable">
									<tr>
										<td class="tdleft_bold"><span><b>计划单号</b></span></td>
										<td class="b_font" colspan="3">
											<el-input
												v-model="billid"
												ref="billid"
												@keyup.enter.native="EnterEvent('billid')"
												style="min-width:200px;"
											></el-input>
										</td>
									</tr>
									<tr>
										<td class="tdleft_bold"><span><b>商品编号</b></span></td>
										<td class="b_font" colspan="3">
											<el-input
												v-model="cargobarcode"
												ref="cargobarcode"
												@keyup.enter.native="EnterEvent('cargobarcode')"
												style="min-width:200px;"
												:disabled="inputenabled"
											></el-input>
										</td>
									</tr>
									<tr>
										<td colspan="4">
											<div style="text-align:left;font-size:14pt;margin-left:10px">已扫描<span style="color:#4489ce;font-weight:bold;"> {{cargoscancount}} </span>个商品</div>
										</td>
									</tr>
								</table>
								</div>
							</td>
							<td valign="top">
								<div class="tCode"><img src="../../static/system_01/image/2.png" style="width:300px" /></div>
								<div class="tips" style="text-align:left;font-size:14pt;">跳过验货请扫描此条码</div>
							</td>
						</tr>
						<tr>
							<td rowspan="3" valign="top" colspan="2">
								<tableui style="width:100%;margin-top:10px" gridheight="320px" editcell="0" :tableData="cargolist" :columns="cargocolumns" :stripe="false" :rowclassname="setrowclass"></tableui>
								<span v-if="cargolist.length>0">共{{cargolist.length}}条数据</span>
							</td>
						</tr>
					</table>
				</el-col>
			</el-row>		
		
		</el-form>
		<errorwin ref="errorwin" @closeerrorwin="closeerrorwin"></errorwin>
	</div>
</template>
<script>
import tableui from '@/components/table/tablegrid.vue';
import errorwin from '@/components/order/errorwin.vue';
import Utils from '../../lib/util.js';
export default {
	components: {
		tableui,
		errorwin
	},
	data() {
		return { 
			handletype:'',
			windowHeight: (window.innerHeight * 88) / 100,
			isread:true,
			stockmain:{},
			billid:'',
			cargobarcode:'',
			cargoscancount:0,
			currentstate:'',
			cargolist:[],
			divclass:'storageoutprint',
			cargocolumns: [
				{ field: 'cargo_id', title: '商品id', type: 'text', width: '80', sortable: false,colshow:0 },
				{ field: 'cno', title: '商品编号', type: 'text', width: '100', sortable: false },
				{ field: 'cnameall', title: '商品全名', type: 'text', width: '120', sortable: false },
				{ field: 'num', title: '数量', type: 'text', width: '120', sortable: false },{ field: 'scannum', title: '已验货数量', type: 'text', width: '80', sortable: false }
			],
			scancount:0,
			inputenabled:false
		};
	},
	mounted() {
		this.$apipost.get.getTheme().then(res => {
			import('../../static/' + res + '/style/wm/storageprint.scss');
		});
	},
	methods: {
		init(param){
			if(param.handletype!=undefined)
				this.handletype=param.handletype;
		},
		setrowclass(e) {
			if (e.row.num == e.row.scannum) return 'finishedrow';
			else return '';
		},
		EnterEvent(control){
			this.currentstate=control;
			if (control == 'billid') {
				//获取订单信息
				this.billid = this.billid.trim();
				this.ScanPkVal(this.currentstate);
			}
			if(control=='cargobarcode'){
				this.cargobarcode = this.cargobarcode.trim();
				this.ScanCargo();
			}
		},
		//扫描单号触发事件
		ScanPkVal(type) {
			var that=this;
			var isgo = true;
			if (type == 'billid') {
				if (this.billid == '') isgo = false;
			}
			if(isgo){
				//获取单据详情
				var paraminfo={
					billid:this.billid,
					type:'outstockplan'
				}
				this.inputenabled=true;
				this.$tool.loading('正在读取信息', this.divclass);
				this.$apipost.get.GetStock({ paraminfo: paraminfo }).then(res => {
					this.$tool.loadingclose();
					if(res.state=='1'){
						if(res.stockmain!=undefined)
							that.stockmain=res.stockmain;
						if(res.cargolist!=undefined){
							if(res.cargolist.length>0){
								//商品按编号汇总
								var list=[],isexists=false;
								res.cargolist.forEach(e=>{
									isexists=false;
									list.forEach(b=>{
										if(e.cno==b.cno)
										{
											isexists=true;
											b.num=parseInt(b.num)+parseInt(e.num);
											return false;
										}
									});
									if(!isexists)
										list.push(e);
								});
								that.cargolist=list;
							}
							else
								this.$refs.errorwin.init({errormsg:'此单据无商品明细',isread:that.isread});						
						}
						that.printpicking();
					}
					else
						this.$refs.errorwin.init({errormsg:res.message,isread:that.isread});
				});
			}
		},
		printpicking(){
			var that=this;
			var paraminfo = {
				billid:this.billid
			};
			this.$tool.loading('正在查找货架',this.divclass);
			this.$apipost.post.SetCargoShelves({ paraminfo: paraminfo }).then(res => {
					this.$tool.loadingclose();
					if (res.state == '0') {
						that.inputenabled=true;
						this.$tool.message(res.message, 0);
					}
					else
					{
						if(res.message!=undefined){
							this.$tool.message(res.message, 0);
							if(res.filename!=undefined){
								that.$tool.downfile(that,res.filename,res.batch);
							}
						}
						else{
							that.inputenabled=false;
							setTimeout(function(){
								that.$refs.cargobarcode.focus();
							},100);
						}
					}
				}).catch(() => {});	
		},
		ScanCargo(){
			var that=this,cno='';
			if(that.cargobarcode==''){
				return false;
			}
			else{
				if (this.cargobarcode == '2') {//表示调过此单,不出库此单
					this.scancargofinished(2);
				}
				else{
					var isexists=false,isgo=true;
					var num=0;
					that.cargolist.forEach(e=>{
						if(e.cno==that.cargobarcode){
							num=e.num;
							if(parseInt(e.scannum)==e.num){
								this.$refs.errorwin.init({errormsg:'此商品已扫描',isread:that.isread});
								isgo=false;
							}
							isexists=true;
							cno=e.cno;
							return false;
						}
					});
					if(!isgo){
						return false;
					}
					if (!isexists) {
						this.$refs.errorwin.init({errormsg:'此商品不属于当前订单',isread:that.isread});
						return false;
					}
					var paraminfo={
						cno:cno,
						storehouse:this.stockmain.storehouse,
						num:num
					}
					this.$tool.loading('正在检测库存', this.divclass);
					//检测商品库存
					this.$apipost.get.CheckStockNum({ paraminfo: paraminfo }).then(res => {
						this.$tool.loadingclose();
						if(res.state=='1'){
							that.cargoscancount=that.cargoscancount+1;
							//累加数量
							that.cargolist.forEach(e=>{
								if(e.cno==that.cargobarcode){
									e.scannum = parseInt(e.scannum) + 1;
									return false;
								}
							});
							var checkscan = that.cargolist.filter(item => item.scannum != item.num);
							if (checkscan.length == 0) {
								that.scancargofinished(1);
							} else {
								that.cargobarcode = '';
								that.$refs.cargobarcode.focus();
							}
						}
						else
							this.$refs.errorwin.init({errormsg:res.message,isread:that.isread});
					});
				}
			}
		},
		scancargofinished(type){
			var that=this;
			if(type=='2')
				this.ResetPage();
			else{
				//出库
				var paraminfo={
					billid:this.billid,
					userid: localStorage.getItem('userid')
				}
				//debugger
				this.$tool.loading('正在出库', that.divclass);
				this.$apipost.post.SureStockOut({ paraminfo: paraminfo }).then(res => {
					this.$tool.loadingclose();
					if (res.state == '1') {
						this.$tool.ReadMsg('出库成功');
						this.$tool.message('出库成功', 1);
						that.scancount=parseInt(that.scancount)+1;
						that.ResetPage();
					} else {
						this.$tool.ReadMsg(res.message);
						this.$refs.errorwin.init({errormsg:res.message,isread:that.isread});
					}
				});
			}
		},
		ResetPage(){
			this.billid='';
			this.cargobarcode='';
			this.cargolist=[];
			this.stockmain={};
			this.$refs.billid.focus();
		},
		closeerrorwin(e){
			this._data[this.currentstate]='';
			this.$refs[this.currentstate].focus();
		}
	},
}
	
</script>
<style>
.body{
	background-color:#ffffff;
}
</style>
